import React, { useMemo } from 'react'
import { ImageAsset, TextAsset, VideoAsset } from '~/models/Asset'
import TextAssetOverlay from './TextAssetOverlay'
import ImageAssetOverlay from './ImageAssetOverlay'
import VideoAssetOverlay from './VideoAssetOverlay'
import { getAbsoluteAssetSize } from '../../../../helpers/getAbsoluteAssetSize'

const AssetOverlay = props => {
  const { asset, referenceAsset } = props
  const size = useMemo(() => {
    if (asset instanceof TextAsset) {
      return undefined
    }
    return getAbsoluteAssetSize(asset, referenceAsset)
  }, [ asset, referenceAsset ])

  switch (true) {
    case asset instanceof TextAsset:
      return <TextAssetOverlay {...props} />
    case asset instanceof ImageAsset:
      return <ImageAssetOverlay {...props} size={size} />
    case asset instanceof VideoAsset:
      return <VideoAssetOverlay {...props} size={size} />
    default:
      return null
  }
}

export default AssetOverlay
